import { useEffect, useRef } from "react";

const BLOBS = [
  { color: "39,179,176", r: 0.55, x: 0.72, y: 0.28, sx: 0.11, sy: 0.07, sp: 0.9, a: 0.34 },
  { color: "168,213,194", r: 0.45, x: 0.20, y: 0.68, sx: 0.09, sy: 0.11, sp: 0.7, a: 0.22 },
  { color: "39,179,176", r: 0.62, x: 0.45, y: 0.95, sx: 0.13, sy: 0.05, sp: 0.55, a: 0.18 },
  { color: "16,90,110", r: 0.5, x: 0.05, y: 0.15, sx: 0.06, sy: 0.09, sp: 0.8, a: 0.3 },
];

export default function Aurora({ className = "" }) {
  const ref = useRef(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    let w = 0;
    let h = 0;
    let raf;
    let t = Math.random() * 100;

    const resize = () => {
      w = canvas.offsetWidth;
      h = canvas.offsetHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };
    resize();
    window.addEventListener("resize", resize);

    const draw = () => {
      t += 0.0035;
      ctx.clearRect(0, 0, w, h);
      for (const b of BLOBS) {
        const cx = (b.x + Math.sin(t * b.sp) * b.sx) * w;
        const cy = (b.y + Math.cos(t * b.sp * 1.3) * b.sy) * h;
        const radius = Math.max(w, h) * b.r;
        const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius);
        g.addColorStop(0, `rgba(${b.color},${b.a})`);
        g.addColorStop(1, `rgba(${b.color},0)`);
        ctx.fillStyle = g;
        ctx.fillRect(0, 0, w, h);
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={ref} className={className} aria-hidden="true" />;
}
